import {Box, Grid, Typography} from '@mui/material';

interface ComparisonKeyProps {
  name: string;
  barColor: string;
}
export const ComparisonKey = ({name, barColor}: ComparisonKeyProps) => {
  return (
    <Grid item display='flex' justifyContent='flex-start' alignItems='center' padding='8px'>
      <Box
        height='100%'
        minWidth='8px'
        minHeight='30px'
        borderRadius='8px'
        sx={{backgroundColor: barColor, maxWidth: '8px'}}
      />
      <Typography variant='body1' paddingLeft='8px'>
        {name}
      </Typography>
    </Grid>
  );
};
